import { WMSelect, WMSelectOption as _WMSelectOption, WMSelectValue, WMTooltip } from '@walkme/wm-ui';
import React, { useMemo, useState } from 'react';
import { dataTestId } from './RecipientsListModal';
import classes from './RecipientsListModal.module.scss';
import { useTranslation } from 'react-i18next';

export interface OptionTypeBase {
  [key: string]: any;
}
export type WMSelectOption = OptionTypeBase & _WMSelectOption;

const keyPrefix = 'components.audiences.recipientsListModal.recipientsModalTitle';

export const ALL_IN_NOTIFICATION_ID = 'all for notification';

export const RecipientsModalTitle = ({
    title,
    notificationName,
    audiences,
    setSelectedAudeince
}: {
    title: string;
    notificationName: string;
    audiences?: { title: string; id: string }[];
    setSelectedAudeince: (selectedAudience: { title: string; audienceId: string }) => void;
}) => {
    const { t } = useTranslation('', { keyPrefix });

    const opts = useMemo(() => {
        return [{ title: t('all'), id: ALL_IN_NOTIFICATION_ID }, ...(audiences || [])].map(it => ({ ...it, label: it.title, value: it.id }));
    }, [audiences, t]);
    const selectedOption = opts.find(a => a.title === title);
    const [isMenuOpen, setMenuOpen] = useState(false);
    return (
        <>
            <WMSelect
                defaultValue={selectedOption}
                onChange={(option: WMSelectValue | null) => {
                    const opt = option as WMSelectOption;
                    const title = opt.id === ALL_IN_NOTIFICATION_ID ? t('allAudiences', { notificationName }) : opt.title!;
                    setSelectedAudeince({ title, audienceId: opt.id });
                }}
                options={opts}
                className={classes.select}
                classes={{ dropdownIndicator: isMenuOpen ? classes.dropDownIconOpened : classes.dropDownIcon }}
                isPopout
                menuPortalTarget={null}
                popoutSelectProps={{
                    targetProps: {
                        className: classes.selectTarget,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        variant: 'outlined'
                    },
                    menuPlacement: 'bottom-end',
                    hideTooltip: true,
                    onToggleOpen: (isOpen: boolean) => setMenuOpen(isOpen),
                    classes: {
                        valueContainer: classes.selectValueContainer,
                        dropdownIndicator: isMenuOpen ? classes.dropDownIconOpened : classes.dropDownIcon
                    }
                }}
                testKey={`${dataTestId}-header-audiences-select`}
            />
            <WMTooltip title={t('showingCurrentStatus')}>
                <div className={classes.tooltipIcon}>?</div>
            </WMTooltip>
        </>
    );
};
